import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import "./App.css";
import { InquiryProvider } from "./context/InquiryContext";
import { SettingsProvider } from "./context/SettingsContext";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import MobileBar from "./components/layout/MobileBar";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import B2B from "./pages/B2B";
import Inquiry from "./pages/Inquiry";
import SizeChart from "./pages/SizeChart";
import Moq from "./pages/Moq";
import Contact from "./pages/Contact";
import Track from "./pages/Track";
import ShippingPolicy from "./pages/ShippingPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import NotFound from "./pages/NotFound";
import WhatsAppFloat from "./components/WhatsAppFloat";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09 }}>
        <SettingsProvider>
          <InquiryProvider>
            <BrowserRouter>
              <ScrollToTop />
              <div className="noise-overlay" aria-hidden="true" />
              <Navbar />
              <main className="pb-14 md:pb-0">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:id" element={<ProductDetail />} />
                  <Route path="/b2b" element={<B2B />} />
                  <Route path="/inquiry" element={<Inquiry />} />
                  <Route path="/size-chart" element={<SizeChart />} />
                  <Route path="/moq" element={<Moq />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/track" element={<Track />} />
                  <Route path="/shipping-policy" element={<ShippingPolicy />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsAndConditions />} />
                  <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
              <MobileBar />
              <WhatsAppFloat />
              <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0 } }} />
            </BrowserRouter>
          </InquiryProvider>
        </SettingsProvider>
      </ReactLenis>
  );
}

export default App;
